import { createModel } from '@rematch/core';

import type { RootModel } from '.';
import { PaginationFactory } from '../factory';
import { MobileAppUserTypes } from '../types';

export interface MobileAppUserStoreProps {
    mobileAppUser: MobileAppUserTypes.Model;
    pagination: PaginationFactory<MobileAppUserTypes.Model>;
    modal: {
        details: boolean;
    };
    loading: {
        fetchMany: boolean;
        getById: boolean;
        update: boolean;
    };
    customers: MobileAppUserTypes.CustomerForFilter[];
}

export const mobileAppUserInitialState = {
    mobileAppUser: {} as MobileAppUserTypes.Model,
    pagination: {} as PaginationFactory<MobileAppUserTypes.Model>,
    loading: {
        fetchMany: false,
        getById: false,
        update: false,
    },
    modal: {
        details: false,
    },
    customers: [] as MobileAppUserTypes.CustomerForFilter[],
};

export const mobileAppUser = createModel<RootModel>()({
    state: mobileAppUserInitialState,
    reducers: {
        boot: (store) => {
            store = mobileAppUserInitialState;
        },
        setMobileAppUser: (
            store,
            mobileAppUser: MobileAppUserTypes.Model
        ) => {
            store.mobileAppUser = mobileAppUser;
        },
        toggleModal: (store, prop: keyof MobileAppUserStoreProps['modal'], v: boolean) => {
            if (!store.modal) {
                store.modal = mobileAppUserInitialState.modal;
            }

            if (typeof store.modal[prop] !== 'boolean' || store.modal[prop] === undefined) {
                store.modal = {
                    ...store.modal,
                    [prop]: v,
                };
            }

            store.modal[prop] = v;
        },
        toggleLoading: (
            store, prop: keyof MobileAppUserStoreProps['loading'], v: boolean) => {
            store.loading[prop] = v;
        },
        setPagination:
            (store, pagination: PaginationFactory<MobileAppUserTypes.Model>) => {
                store.pagination = pagination;
            },
        setCustomers: (store, customers: MobileAppUserTypes.CustomerForFilter[]) => {
            store.customers = customers;
        },
    },
});
